
export function validateEmail(email: string) {
	const res = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return res.test(String(email).toLowerCase());
}

export function calculateAge(dtCompare: Date) {
    var now = new Date();

    var nowYear = now.getFullYear();
    var nowMonth = now.getMonth();
    var currentDay = now.getDate(); 

    var calculatedAge = nowYear - dtCompare.getFullYear();

    if (nowMonth < dtCompare.getMonth()) {
        calculatedAge--;
    }
    if (dtCompare.getMonth() === nowMonth && currentDay < dtCompare.getDate()) {
        calculatedAge--;
    }
    return calculatedAge;
}